(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    // click-directive to switch user-view 
    module.directive('quickSidebarSwitchUser', ['AgendaTransitionService', 'UserService', '$localStorage', function (AgendaTransitionService, UserService, $localStorage) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '@' // user id
            }
        };
        return directive;

        function link(scope, element, attrs) {

            // click listener
            element.on('click', function () {
                if ($localStorage.ExternalPatientIncomingData)
                {
                    UserService.clearExternalPatient();
                }
                switching();
            });

            // switching/changing agenda
            function switching() {
                
                AgendaTransitionService.change(parseInt(scope.id), attrs.date);
            } // show

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();